import moment from 'moment';
import { Organization, Hours } from 'models/organization';

export const millingDeadlineDate = (millingDeadlineDays: number, lab: Organization): Date | null => {
    const deadlineDate = moment().add(millingDeadlineDays, 'days').format('YYYY-MM-DD');
    const holidays = lab.holidayDays.concat(lab.unavailableLabDates || []);
    const inActiveDays: number[] = [];
    if (lab?.openingHours) {
        lab.openingHours.forEach((dayObj: Hours, index: number) => {
            if (!dayObj.active) {
                let day = index + 1;
                day = day === 7 ? 0 : day;
                inActiveDays.push(day);
            }
        });
    }
    // If lab have all days as inactive
    if (inActiveDays.length === 7) {
        return null;
    }
    return previousWorkingDay(deadlineDate, holidays, inActiveDays);
};
const previousWorkingDay = (deadlineDate: string, holidays: number[], inActiveDays: number[]) => {
    let inActiveDayIndex,
        holidayIndex,
        previousDate = moment(deadlineDate);
    const previousDateMilliseconds = previousDate.toDate().setHours(0, 0, 0, 0);
    holidayIndex = holidays.indexOf(previousDateMilliseconds);
    inActiveDayIndex = inActiveDays.indexOf(previousDate.toDate().getDay());
    while (inActiveDayIndex > -1 || holidayIndex > -1) {
        previousDate = moment(previousDate).subtract(1, 'days');
        const latestDeliveryDateMilliseconds = previousDate.toDate().setHours(0, 0, 0, 0);
        holidayIndex = holidays.indexOf(latestDeliveryDateMilliseconds);
        inActiveDayIndex = inActiveDays.indexOf(previousDate.toDate().getDay());
    }
    return previousDate.toDate();
};
